<template>
  <teleport to="body">
    <div v-if="isVisible" :class="backdropClasses">
      <div class="modal-container" :class="$attrs.class" :style="props.style">
        <slot></slot>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  direction: {
    type: String,
    default: 'center',
  },
  style: {
    type: Object,
    default: () => ({}),
  },
});

const isVisible = ref(false);

const backdropClasses = computed(() => {
  return [
    'backdrop',
    props.direction === 'center'
      ? 'items-center justify-center'
      : 'justify-end',
  ];
});

// 부모 컴포넌트에서 접근하기 위한 함수.
const open = () => {
  isVisible.value = true;
};

const close = () => {
  isVisible.value = false;
};

// defineExpose 해줘야 부모함수에서 접근 가능
defineExpose({ open, close });
</script>

<style lang="scss" scoped>
.backdrop {
  @apply flex fixed bg-black bg-opacity-80 w-screen h-screen left-0 top-0 items-center justify-center;
  z-index: 150;
}
.modal-container {
  border-radius: 8px;
  background-color: white;
  width: 80%;
  max-width: 400px;
  padding: 24px;
}

@media (max-width: 499px) {
  .modal-container {
    width: 90%;
    max-height: 90%;
    overflow-y: auto;
  }
}
</style>
